import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n/i18n';
import vuetify from './plugins/vuetify';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import './styles/app.css';
import beforeRun from './beforeRun'

Vue.config.productionTip = false;
const options = {
    position: 'bottom-right',
    timeout: 5000
};

Vue.use(Toast, options);

// Eliminar cookie balanceo
document.cookie = "FVROUTEID=; max-age=0; path=/";

beforeRun().then(() => {
    new Vue({
        router,
        store,
        i18n,
        vuetify,
        render: (h) => h(App)
    }).$mount('#app');
});
